import * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StateOverheadEeCodesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type StateOverheadEeCodesQuery = { __typename?: 'QueryModel', overheadEeCodes?: { __typename?: 'OverheadEeCodeQueryModel', stateEeCodes?: Array<{ __typename?: 'StateOverheadEeCode', state: string, eeCode: string } | null> | null } | null };


export const StateOverheadEeCodesDocument = gql`
    query StateOverheadEeCodes {
  overheadEeCodes {
    stateEeCodes {
      state
      eeCode
    }
  }
}
    `;

/**
 * __useStateOverheadEeCodesQuery__
 *
 * To run a query within a React component, call `useStateOverheadEeCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStateOverheadEeCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStateOverheadEeCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useStateOverheadEeCodesQuery(baseOptions?: Apollo.QueryHookOptions<StateOverheadEeCodesQuery, StateOverheadEeCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StateOverheadEeCodesQuery, StateOverheadEeCodesQueryVariables>(StateOverheadEeCodesDocument, options);
      }
export function useStateOverheadEeCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StateOverheadEeCodesQuery, StateOverheadEeCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StateOverheadEeCodesQuery, StateOverheadEeCodesQueryVariables>(StateOverheadEeCodesDocument, options);
        }
export type StateOverheadEeCodesQueryHookResult = ReturnType<typeof useStateOverheadEeCodesQuery>;
export type StateOverheadEeCodesLazyQueryHookResult = ReturnType<typeof useStateOverheadEeCodesLazyQuery>;
export type StateOverheadEeCodesQueryResult = Apollo.QueryResult<StateOverheadEeCodesQuery, StateOverheadEeCodesQueryVariables>;